<path
    fill="currentColor"
    d="M20.6348 30.6665c-.351 0-.6885-.1333-.9585-.3867l-12.58104-12.44c-.24298-.24-.37797-.5466-.39147-.88l-.25648-5.3333c-.0405-.7333.53996-1.36 1.2824-1.4.72895-.0267 1.3769.5333 1.4174 1.2667l.22948 4.8266L20.6483 27.4532l8.2209-8.12c.5264-.52 1.3768-.52 1.9033 0s.5265 1.36 0 1.88l-9.1793 9.0666c-.27.2534-.6075.3867-.9584.3867Z"
/><path
    fill="currentColor"
    d="M26.7912 17.8133c-.351 0-.6885-.1334-.9585-.3867l-8.7878-8.68001-9.58432-.45333c-.33747-.01333-.64795-.16-.89093-.38667L2.22297 3.61326c-.52646-.52-.52646-1.36 0-1.88.52646-.52 1.3769-.52 1.90336 0l3.98221 3.93333 9.58426.45334c.3375.01333.648.16.891.38667l9.1658 9.0533c.5265.52.5265 1.36 0 1.88-.27.24-.621.3734-.9584.3734Z"
/><path
    fill="currentColor"
    d="M14.1538 15.1731c1.1183 0 2.0248-.8954 2.0248-2s-.9065-2-2.0248-2-2.0249.8954-2.0249 2 .9066 2 2.0249 2Z"
/>
